import * as React from 'react'

import { useBloomreachPageRoutes, useBloomreachProductRoutes } from '@grandvisionhq/bloomreach'
import { ProductDetailSlotsProvider } from '@grandvisionhq/fun-products'
import { NextPage, withErrorPage } from '@grandvisionhq/next'
import { GraphCrossSellProducts } from '@grandvisionhq/search'
import { useFeatureToggles } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'
import { ErrorCase, InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/product-detail'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../../components/error-props'
import { withCart } from '../../components/hocs/with-cart'
import { PromoteInstallmentsGraphContainer as PromoteInstallments } from '../../components/slot-components'
import { getAlgoliaCrossSellConfig } from '../../util/algolia'
import '@grandvisionhq/lib-lime/css'

import '@grandvisionhq/reviews/dist/index.css'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const [_, { formatProductUrl }] = useBloomreachProductRoutes()
  const { routes } = useBloomreachPageRoutes()
  const { isCrossSellEnabled } = useFeatureToggles()

  if ('statusCode' in props) {
    // If an error status code was returned, render the error page.
    return null
  }

  const adjustedRoutes = {
    ...routes,
    'book-appointment': routes['appointment-book'],
  }
  const { productType } = props.product
  const crossSellConfig = getAlgoliaCrossSellConfig(props.product.productType)
  const specificationConfiguration = []
  const AfterPrice = () => <PromoteInstallments productType={productType} />
  const SecondaryProductInfoSlotA = isCrossSellEnabled
    ? () => (
        <GraphCrossSellProducts
          activeVariant={props.activeVariant}
          product={props.product}
          formatProductUrl={formatProductUrl}
          algoliaConfig={crossSellConfig}
        />
      )
    : undefined
  return (
    <ProductDetailSlotsProvider
      slots={{
        AfterPrice,
        SecondaryProductInfoSlotA,
      }}
    >
      <Page
        {...props}
        specificationConfiguration={specificationConfiguration}
        colorFeatureIcons="orange"
        adjustedPageRoutes={adjustedRoutes}
      />
    </ProductDetailSlotsProvider>
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout(),
  withCart({ readOnly: true })
)(ProductDetailPage)
